// extracted by mini-css-extract-plugin
module.exports = {"carouselBase":"styles_carouselBase__Wq2WO","carousel":"styles_carousel__3_JfP","pagination":"styles_pagination__BDOtu"};